var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRewardRedeemGiftIcon = function SvgRewardRedeemGiftIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 14H7C6.0335 14 5.25 14.7835 5.25 15.75V19.25C5.25 20.2165 6.0335 21 7 21H35C35.9665 21 36.75 20.2165 36.75 19.25V15.75C36.75 14.7835 35.9665 14 35 14Z",
    stroke: "currentColor",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14V36.75",
    stroke: "currentColor",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 21V33.25C33.25 34.1783 32.8813 35.0685 32.2249 35.7249C31.5685 36.3813 30.6783 36.75 29.75 36.75H12.25C11.3217 36.75 10.4315 36.3813 9.77513 35.7249C9.11875 35.0685 8.75 34.1783 8.75 33.25V21",
    stroke: "currentColor",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 14.0008C11.9647 14.0008 10.8519 13.5398 10.0314 12.7194C9.21094 11.8989 8.75 10.7861 8.75 9.62576C8.75 8.46544 9.21094 7.35264 10.0314 6.53217C10.8519 5.7117 11.9647 5.25077 13.125 5.25077C14.8132 5.22135 16.4675 6.04047 17.8723 7.6013C19.277 9.16212 20.367 11.3922 21 14.0008C21.633 11.3922 22.723 9.16212 24.1277 7.6013C25.5325 6.04047 27.1868 5.22135 28.875 5.25077C30.0353 5.25077 31.1481 5.7117 31.9686 6.53217C32.7891 7.35264 33.25 8.46544 33.25 9.62576C33.25 10.7861 32.7891 11.8989 31.9686 12.7194C31.1481 13.5398 30.0353 14.0008 28.875 14.0008",
    stroke: "currentColor",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRewardRedeemGiftIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reward-redeem-gift-icon.23bcc6f0.svg";
export { ForwardRef as ReactComponent };